import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ShapeTriangleUp = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 28H9C6.243 28 4 25.757 4 23C4 22.134 4.226 21.28 4.654 20.527L11.67 6.5C12.56 4.958 14.22 4 16 4C17.78 4 19.44 4.958 20.33 6.5L20.358 6.553L27.345 20.528C27.773 21.28 27.999 22.135 27.999 23.001C27.999 25.758 25.756 28.001 22.999 28.001L23 28ZM13.416 7.476L6.402 21.5C6.139 21.956 6 22.474 6 23C6 24.654 7.346 26 9 26H23C24.654 26 26 24.654 26 23C26 22.474 25.861 21.956 25.598 21.5L25.569 21.447L18.583 7.476C18.046 6.565 17.058 6 15.999 6C14.94 6 13.952 6.565 13.415 7.476H13.416Z" />
	</svg>
);

export default ShapeTriangleUp;
